import React from 'react';
import { Content } from 'carbon-components-react/lib/components/UIShell';
import { useSelector } from 'react-redux';
import {
  selectIsShowHideTriggered,
  selectorAlertNotificationShowHide
} from 'redux/session/selectors';

export interface PageProps {
  sideRailButtons?: Object;
}

/*
 * CUSTOM RIGHT HAND SIDE HEADER PANEL
 */
export const MainContainer: React.FC<PageProps> = (props: any) => {
  const { sideRailButtons } = props;
  const isShowHideTriggered = useSelector(selectIsShowHideTriggered);
  const alertNotificationToggle = useSelector(
    selectorAlertNotificationShowHide
  );

  return props.children ? (
    <Content
      id="main-content"
      className={`${
        alertNotificationToggle ? 'noti-alert-notification-main' : ''
      } ${sideRailButtons ? 'sideRailMapNavActive' : ''} ${
        isShowHideTriggered ? 'shrinkPanel' : ''
      }`}
    >
      {props.children}
    </Content>
  ) : null;
};
